import {Button, Snackbar} from '@mui/material';
import {IconCopy} from '../../assets';
import {useState} from 'react';
import './CustomZoomControl.scss';
import {Language} from '../../context/LanguageContext';
export default function CustomZoomControl({
  lat = 2.208543218591131,
  lng = 108.03955078125,
  mapRef,
}) {
  const [open, setOpen] = useState(false);
  const {language, newObj} = Language();
  function fallbackCopyText(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed'; // avoid scrolling to bottom
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }
  return (
    <div className='leaflet-bottom leaflet-right czc_ctr'>
      <div className='czc_latlong'>
        <p id='czc_coordinate'>
          {lat.toFixed(6)}, {lng.toFixed(6)}
        </p>
        <Snackbar
          anchorOrigin={{vertical: 'top', horizontal: 'right'}}
          open={open}
          onClose={() => setOpen(false)}
          message={newObj.CopyToClipboard[language]}
          className='czc_snackbar'
        />
        <Button
          className='czc_icon_copy_btn'
          onClick={() => {
            var copyText = document.getElementById('czc_coordinate');
            if (!navigator.clipboard) fallbackCopyText(copyText.innerText);
            else navigator.clipboard.writeText(copyText.innerText);
            setOpen(true);
            setTimeout(() => {
              setOpen(false);
            }, 2000);
          }}
        >
          <img src={IconCopy} alt='icon_copy' className='czc_icon_copy' />
        </Button>
      </div>
      <div className='czc_button'>
        <Button
          variant='contained'
          className='czc_zoom_out'
          onClick={() => {
            mapRef.current.setZoom(mapRef.current.getZoom() - 2);
          }}
          disabled={mapRef?.current?.getZoom() <= 6}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            height='20px'
            viewBox='0 -960 960 960'
            width='20px'
            fill='#e8eaed'
          >
            <path d='M232-444v-72h496v72H232Z' />
          </svg>
        </Button>
        <Button
          variant='contained'
          className='czc_zoom_in'
          onClick={() => {
            mapRef.current.setZoom(mapRef.current.getZoom() + 2);
          }}
          disabled={mapRef?.current?.getZoom() === 17}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            height='24px'
            viewBox='0 -960 960 960'
            width='24px'
            fill='#e8eaed'
          >
            <path d='M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z' />
          </svg>
        </Button>
      </div>
    </div>
  );
}
